import { render, staticRenderFns } from "./PaymentPoyntInputs.vue?vue&type=template&id=267a36b1&"
import script from "./PaymentPoyntInputs.vue?vue&type=script&lang=ts&"
export * from "./PaymentPoyntInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports